// Reações rápidas + alternância pura (sem React/I/O).
export const REACOES_RAPIDAS: string[] = ['👍', '❤️', '😂', '😮', '😢', '🙏'];

// Reagir com o mesmo emoji remove (null); com outro, substitui.
export function toggleReaction(
  atual: string | null | undefined,
  escolhido: string,
): string | null {
  return atual === escolhido ? null : escolhido;
}
